module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-14 text-white font-weight-700 btn-pay ma-0 full-width my-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/apple-pay.svg"),
      "width": "58",
      "height": "24"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Credit card")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Country or region")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 country-region"
  }, [_c('v-select', {
    staticClass: "pt-0 country",
    attrs: {
      "label": "Choose one",
      "single-line": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _vm._m(6)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-18 btn-confirm ma-0 full-width"
  }, [_vm._v("\n    Pay $565.35\n  ")]), _vm._v(" "), _vm._m(7)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between"
  }, [_c('span', {
    staticClass: "text-dmsans-14 text-grey-2"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-15"
  }, [_vm._v("$519.96")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between my-1"
  }, [_c('span', {
    staticClass: "text-dmsans-14 text-grey-2"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-15"
  }, [_vm._v("$7.70")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between"
  }, [_c('span', {
    staticClass: "text-dmsans-14 text-grey-2"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-15"
  }, [_vm._v("$37.69")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between"
  }, [_c('span', {
    staticClass: "text-dmsans-16"
  }, [_vm._v("Grand Total ")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-16"
  }, [_vm._v("$565.35")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dmsans-16 text-grey-3 font-weight-400 display-flex align-center full-width mt-2 mb-4"
  }, [_c('hr', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("Or pay with card")]), _vm._v(" "), _c('hr', {
    staticClass: "flex-grow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credit-card mb-5"
  }, [_c('div', {
    staticClass: "display-flex align-center px-3 credit-card__number"
  }, [_c('input', {
    staticClass: "full-width border-none",
    attrs: {
      "type": "text",
      "placeholder": "1234 1234 1234 1234"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/visa.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/master-card.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/american-express.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/discover.svg"),
      "width": "24",
      "height": "16"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center full-width"
  }, [_c('input', {
    staticClass: "border-none width-50 credit-card__month px-3 credit-card__month",
    attrs: {
      "type": "text",
      "placeholder": "MM / YY"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "width-50 px-3 display-flex align-center"
  }, [_c('input', {
    staticClass: "border-none full-width",
    attrs: {
      "type": "text",
      "placeholder": "CVC"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/card.svg"),
      "width": "24",
      "height": "16"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zip"
  }, [_c('input', {
    staticClass: "full-width border-none px-3",
    attrs: {
      "type": "text",
      "placeholder": "ZIP"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 display-flex justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobile/logo_stripe.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08139298","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/components/card.vue
// module id = 1602
// module chunks = 180